module.exports = __webpack_public_path__ + "static/media/banner_red.0639846e.svg";